<template>
  <validation-observer
    v-if="showHomeRenewal"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="home-renewal"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row :label="label">
        <v-row class="flex-column flex-sm-row">
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              :vid="`${stepId}_home-renewal`"
              name="Home Insurance Renewal"
              :rules="rules"
            >
              <qz-select
                v-model="questionData.homeRenewal"
                :data-test="fieldTrackerId.homeRenewal"
                :items="monthsOptions"
                :error-messages="errors"
                placeholder="Choose Month"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ failed }"
              :vid="`${stepId}_home-renewal_0`"
              name="Home Insurance Renewal"
              :rules="{
                required: (stepData.residentialStatus === 'HO') && (stepData.homeRenewal === null),
              }"
            >
              <checkbox-square
                v-model="homeRenewalNoModel"
                :data-test="fieldTrackerId.noHomeRenewal"
                name="home-renewal-dont-know"
                :error="failed"
              >
                I don't know
              </checkbox-square>
            </validation-provider>
          </v-col>
        </v-row>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-home-renewal',
  extends: QuestionBase,
  inject: ['config'],
  data () {
    return {
      monthsOptions: this.helpers.monthsOptions,
      fields: ['homeRenewal'],
      label: 'Please select which month your home insurance is up for renewal',
      // used for split testing
      unwatchResidentialStatus: null,
    };
  },
  computed: {
    showHomeRenewal () {
      return !this.config.hideHomeRenewal && !this.isAdditional && this.stepData.residentialStatus && this.stepData.residentialStatus === 'HO';
    },
    homeRenewalNoModel: {
      get () { return (this.questionData.homeRenewal) !== null && (+this.questionData.homeRenewal === 0); },
      set (val) { this.questionData.homeRenewal = val ? 0 : null; },
    },
    rules () {
      return {
        listOptionRequired: this.stepData.residentialStatus === 'HO',
      };
    },
    fieldTrackerId () {
      return {
        homeRenewal: snakeCase(this.questionFields.homeRenewal),
        noHomeRenewal: `${snakeCase(this.questionFields.homeRenewal)}_no_renewal`,
      };
    },
  },
  created () {
    this.unwatchResidentialStatus = this.$watch('stepData.residentialStatus', (val) => {
      if (val !== 'HO' && this.questionData.homeRenewal !== null) {
        this.questionData.homeRenewal = null;

        return;
      }
      if (val === 'HO' && this.config.hideHomeRenewal) {
        this.questionData.homeRenewal = 0;
      }
    });
  },
};
</script>
